module.exports = __webpack_public_path__ + "assets/img/login_icon4.715bfb1c.png";